
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/toy/[slug]",
      function () {
        return require("private-next-pages/toy/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/toy/[slug]"])
      });
    }
  